export const IsOnPrem = () => {
	return _.config.GetSetting('on-prem') ? true : false;
}